/**
 * Tie the status of a toggle switch to the state of a mutation
 */

import React from 'react'

import { Switch, SwitchProps } from '@mantine/core'
import { UseMutationResult } from '@tanstack/react-query'

interface Props extends SwitchProps {
  mutation: UseMutationResult<boolean, Error, boolean, unknown>
  confirmDisableMessage?: string
}

export const ToggleSwitchForm = (props: Props) => {
  const { mutation, confirmDisableMessage, ...switchProps } = props

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
    if (confirmDisableMessage && !event.currentTarget.checked) {
      if (!confirm(confirmDisableMessage)) return
    }

    mutation.mutate(event.currentTarget.checked)
  }

  return (
    <Switch
      onChange={handleChange}
      disabled={props.mutation.isPending}
      error={props.mutation.error?.message}
      {...switchProps}
    />
  )
}
